import React from "react";

// Three short facts, directly under the hero.
//
// --- why this exists ------------------------------------------------------
//
// The hero says "Put yourself out there" and "a new way to get seen", and
// since the eyebrow came off it says nothing concrete about what WallBurst
// actually is. That was a deliberate choice -- the headline is a hook -- but
// it left the first screenful with no answer to "what am I looking at". This
// is that answer, in three lines, without turning into a feature section.
//
// It also anchors the bottom of the hero. The hero used to dissolve into
// another near-white area with nothing in it, which made the whole page read
// as emptier than it is.
//
// It sits on WHITE, with the hero, and the warm ground starts at the section
// below. This strip belongs to the hero -- it answers "what is this?" about
// the headline above it, not about the section below -- and colouring it as
// the next section moved the page's one ground change a full section early.
//
// --- what is deliberately NOT here ---------------------------------------
//
// No metrics, no logos, no ratings, no screen count. Every one of those would
// be invented at this stage, and a fabricated number under a real photograph
// discredits the photograph.
//
// The rate is not repeated here either. It is already on the hero chip a
// hundred pixels above, and saying "from $25/day" twice in one screenful is
// filler. "The rate on the listing is what you pay" is the more useful claim
// and it is one the product actually keeps -- the cart quotes the device's own
// daily_rate, and the customer-entered rate field that used to contradict it
// is gone.

const POINTS = [
    {
        label: "Inside real businesses",
        detail: "Salons, cafés, gyms, studios, waiting rooms",
    },
    {
        label: "Book by the day",
        detail: "No contract, nothing to print",
    },
    {
        label: "Simple pricing",
        detail: "The rate on the listing is what you pay",
    },
];

export default function ValueStrip() {
    return (
        <section className="vs" aria-label="What WallBurst is">
            <ul className="vs__list">
                {POINTS.map((point) => (
                    <li className="vs__item" key={point.label}>
                        <span className="vs__label">{point.label}</span>
                        <span className="vs__detail">{point.detail}</span>
                    </li>
                ))}
            </ul>
        </section>
    );
}
